// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  rowId: __t.u64().primaryKey().name("row_id"),
  worldId: __t.string().name("world_id"),
  tick: __t.u64(),
  eventType: __t.string().name("event_type"),
  playerId: __t.option(__t.string()).name("player_id"),
  otherPlayerId: __t.option(__t.string()).name("other_player_id"),
  message: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
});
